import { Rocket, LineChart, Globe2, Building2, Landmark } from "lucide-react";
import { Reveal, Kicker } from "../lib/motion";

const AUDIENCES = [
  {
    icon: Rocket,
    title: "Startups & SMEs",
    text: "For founder-led and growing Indian businesses that have outgrown basic bookkeeping but do not yet require a full-time CFO.",
    needs: ["Fractional CFO", "Cash visibility", "Reporting", "Controls", "Compliance", "Investor readiness"],
    cta: "For Startups & SMEs",
  },
  {
    icon: LineChart,
    title: "Funded Technology Companies",
    text: "For SaaS, FinTech, HealthTech and IT-services companies scaling through funding rounds.",
    needs: ["FP&A", "SaaS metrics", "Unit economics", "Board reporting", "Fundraising", "Revenue recognition"],
    cta: "For Funded Companies",
  },
  {
    icon: Globe2,
    title: "Global Capability Centres",
    text: "Controllership, Finance Shared Services, compliance and globally aligned reporting for multinational organisations operating or expanding GCC operations in India.",
    needs: ["Controllership", "Finance Shared Services", "Consolidation", "Transfer-pricing coordination", "Global reporting alignment"],
    cta: "For GCCs",
  },
  {
    icon: Building2,
    title: "Companies Building in India",
    text: "For overseas organisations establishing their first India entity, team or back-office operation.",
    needs: ["Finance setup", "Finance Shared Services Setup", "Accounting", "Payroll coordination", "Compliance", "Banking", "Local finance leadership"],
    cta: "Building in India?",
  },
  {
    icon: Landmark,
    title: "Large Enterprises",
    text: "For established Indian or international businesses requiring specialist senior finance support.",
    needs: ["Controllership", "Finance Shared Services", "Treasury", "Reporting", "Internal controls", "Systems", "Transformation projects"],
    cta: "For Enterprises",
  },
];

const SPANS = ["lg:col-span-2", "lg:col-span-2", "lg:col-span-2", "lg:col-span-3", "lg:col-span-3"];

export const Audiences = () => (
  <section id="who-we-serve" data-testid="audiences-section" className="bg-white py-24 md:py-32 border-t border-border">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal className="max-w-2xl">
        <Kicker>Who We Serve</Kicker>
        <h2 className="mt-6 font-display text-4xl md:text-5xl font-bold tracking-tight text-navy">
          Finance support designed around your stage.
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-6">
        {AUDIENCES.map((a, i) => (
          <Reveal key={a.title} delay={(i % 3) * 0.08} className={SPANS[i]}>
            <article
              data-testid={`audience-card-${i}`}
              className="group relative h-full overflow-hidden rounded-xl border border-border bg-mist p-8 transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-1.5 hover:bg-white hover:shadow-[0_20px_50px_rgba(10,31,60,0.10)]"
            >
              <div
                aria-hidden="true"
                className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-navy/[0.04] transition-transform duration-500 group-hover:scale-150"
              />
              <div className="flex items-center gap-4">
                <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-navy text-white transition-colors duration-300 group-hover:bg-brand group-hover:text-navy">
                  <a.icon size={20} strokeWidth={1.8} />
                </div>
                <h3 className="font-display text-xl md:text-2xl font-bold tracking-tight text-navy">{a.title}</h3>
              </div>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-body">{a.text}</p>
              <div className="mt-5 flex flex-wrap gap-2">
                {a.needs.map((n) => (
                  <span key={n} className="rounded-full border border-navy/10 bg-white px-3 py-1 text-xs font-semibold text-navy/70">
                    {n}
                  </span>
                ))}
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
